import React, { useState } from 'react';
import '../Styles/ProjectCard.css';

export function ProjectCard({ 
	items = [], 
	image, 
	videoUrl,
	imagePosition = 'right',
	buttonText,
	buttonLink,
	onOpen
}) {
	const [isLoaded, setIsLoaded] = useState(false);

	return (
		<div className={`project-content-wrapper fade-in ${imagePosition === 'right' ? 'reverse' : ''}`}>
			
			{image && (
				<div 
					className={`project-image-container image-loader-container ${isLoaded ? 'loaded' : 'loading'}`} 
					onClick={() => onOpen(videoUrl || image)}
				>
					<img 
						src={image} 
						alt="Project Thumbnail" 
						className={`project-section-img ${isLoaded ? 'faded-in' : 'hidden'}`} 
						onLoad={() => setIsLoaded(true)}
					/>

						<div className="play-button-overlay">
							<div className="play-icon"></div>
						</div>
				</div>
			)}

			<div className="project-text-wrapper">
				{items.map((item, index) => {
					if (item.type === 'title') return <p key={index} className="item-title"><b>{item.content}</b></p>;
					if (item.type === 'divider') return <p key={index} className="divider-text" style={{opacity: 0.5}}>{item.content}</p>;
					return <p key={index} className="item-text">{item.content}</p>;
				})}
				
				<div className="button-container">
					<a href={buttonLink} target="_blank" rel="noreferrer" className="project-button">
						{buttonText}
					</a>
				</div>
			</div>
		</div>
	);
}